var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "feature1-section",
    class: {
      'fixed-height': _vm.fixedHeight
    },
    style: _vm.style
  }, [_c('ContainerVue', [_c('div', {
    staticClass: "h-full grid grid-cols-2 gap-x-2 gap-y-2 justify-center align-center items-center sm-md:grid-cols-1"
  }, [_c('div', {
    staticClass: "h-full flex flex-col justify-center sm-md:row-start-1 sm-md:row-span-1"
  }, [_vm.header ? _c('sanity-block-content', {
    staticClass: "heading pb-4",
    attrs: {
      "blocks": _vm.header
    }
  }) : _vm._e(), _vm._v(" "), _vm.subheading ? _c('sanity-block-content', {
    staticClass: "sub-heading pb-4",
    attrs: {
      "blocks": _vm.subheading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm.content.listStyleType ? _c('sanity-block-content', {
    staticClass: "list w-list-unstyled",
    class: [_vm.content.listStyleType, _vm.content.listStyleColor],
    attrs: {
      "blocks": _vm.list
    }
  }) : _c('sanity-block-content', {
    staticClass: "list square teal w-list-unstyled",
    attrs: {
      "blocks": _vm.list
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "h-full flex self-end sm-md:row-start-2 sm-md:row-span-2",
    class: [_vm.featureImageClassObj],
    style: _vm.layout.desktop === 'textOnRight' && 'order: -1'
  }, [_vm.image.asset ? _c('img', {
    staticClass: "justify-self-end self-end mx-auto",
    attrs: {
      "src": _vm.imageUrl(_vm.image.asset),
      "alt": _vm.image.alt
    }
  }) : _vm._e()])])]), _vm._v(" "), _vm.showBgImg ? _c('background-image', {
    attrs: {
      "image": _vm.styles.backgroundImage
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };